// files
import Home from "../../Components/Home/Home"
import HomePage from "./HomePage";
const HomePageLoggedIn = () => {
  return (
    <> 
      <HomePage />
      <Home />
    </>
  )
}
export default HomePageLoggedIn;